import { render, staticRenderFns } from "./ScreenshotsHalls.vue?vue&type=template&id=2c5fcf2b&"
import script from "./ScreenshotsHalls.vue?vue&type=script&lang=js&"
export * from "./ScreenshotsHalls.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotsHalls.vue?vue&type=style&index=0&id=2c5fcf2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports